import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import Resize from './Resize';
import Scroller from './Scroller';
import PositionMap from './PositionMap';
import { keyMapper as defaultKeyMapper } from './util';
import SizeCache from './SizeCache';
import RowCache from './RowCache';
import IndexTree from './IndexTree';
var _DIRECTION = {
  VERTICAL: 'v',
  HORIZONTAL: 'h'
};
export var SCROLL_REASON = {
  REQUESTED_BY_PROPS: 'REQUESTED_BY_PROPS',
  REQUESTED_BY_API: 'REQUESTED_BY_API',
  REQUESTED_BY_RESIZE: 'REQUESTED_BY_RESIZE',
  OBSERVED: 'OBSERVED'
};
export var RESIZE_EFFECT_RESULT = {
  HIT_CACHE_STRATEGY: 'HIT_CACHE_STRATEGY',
  SHOULD_ALIGN_WITH_SCROLL_TO_POSITION: 'SHOULD_ALIGN_WITH_SCROLL_TO_POSITION',
  SCROLL_TO_ROW_READY_WITH_DIFF: 'SCROLL_TO_ROW_READY_WITH_DIFF',
  SCROLL_TO_ROW_READY_WITHOUT_DIFF: 'SCROLL_TO_ROW_READY_WITHOUT_DIFF',
  RESIZE_WITH_SCROLL_TO_ROW: 'RESIZE_WITH_SCROLL_TO_ROW',
  RESIZE_WITH_OTHER: 'RESIZE_WITH_OTHER'
}; // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Element/scrollIntoView

export var SCROLL_TO_ROW_ALIGN = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
  NEAREST: 'nearest'
};
var CALC_REASON;

(function (CALC_REASON) {
  CALC_REASON["RESIZED"] = "RESIZED";
  CALC_REASON["REFRESH"] = "REFRESH";
  CALC_REASON["SCROLL"] = "SCROLL";
})(CALC_REASON || (CALC_REASON = {}));

var styles = {
  wrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'overlay',
    transform: 'translateY(0)',
    contain: 'strict'
  }
};
var defaultProps = {
  direction: _DIRECTION.VERTICAL,
  numberOfSections: 1,
  variableHeight: false,
  scrollOnWindow: false,
  height: window.innerHeight,
  position: 0,
  rowHeight: 0,
  headerHeight: 0,
  footerHeight: 0,
  sectionHeaderHeight: 0,
  sectionFooterHeight: 0,
  estimatedRowHeight: 0,
  estimatedSectionHeaderHeight: 0,
  estimatedSectionFooterHeight: 0,
  bufferSize: 20,
  minimumBufferDistance: 5,
  scrollLock: false,
  useTransform: true
};

var List = /*#__PURE__*/function (_React$Component) {
  _inherits(List, _React$Component);

  var _super = _createSuper(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_resetScrollToRowReadyTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "_timers", void 0);

    _defineProperty(_assertThisInitialized(_this), "_refScroller", void 0);

    _defineProperty(_assertThisInitialized(_this), "_updatePosId", void 0);

    _defineProperty(_assertThisInitialized(_this), "_mergeEnabled", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onContainerResize", scroller => {
      var containerSize = scroller.getContainerSize();

      if (_this.state.containerHeight === containerSize.y) {
        return;
      }

      _this.state.containerHeight = containerSize.y;
      var position = scroller.getPosition();

      _this._calcRenderInfoAndRerender(position, CALC_REASON.RESIZED);

      if (_this.props.onContainerResize) {
        _this.props.onContainerResize(containerSize);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onScroll", (position, _ref) => {
      var _this$props$unstableT;

      var {
        forward,
        isUserScrolling,
        isMouseDown
      } = _ref;
      var {
        scrollReason
      } = _this.state; // props.scrollToRow 和 row resize 导致的滚动需要走 RESIZED 逻辑，Resize 逻辑做了特殊处理
      // 可以防止元素创建后立即销毁，进一步可以减少 ResizeObserer loop limit 的错误
      // 对于 ResizeObserver loop limit 的错误目前还没彻底解决，但是对 ui 表现不影响
      // 对于 REQUESTED_BY_API 不能特殊处理，否则会导致渲染的 range 过大
      //    假设从 0 跳到 1000，Resize 逻辑会把 renderIndexTop 计算成 0

      var {
        REQUESTED_BY_PROPS,
        REQUESTED_BY_RESIZE
      } = SCROLL_REASON;
      var calcReason = scrollReason === REQUESTED_BY_PROPS || scrollReason === REQUESTED_BY_RESIZE ? CALC_REASON.RESIZED : CALC_REASON.SCROLL;

      if ((_this$props$unstableT = _this.props.unstableTrackAPI) !== null && _this$props$unstableT !== void 0 && _this$props$unstableT.active) {
        _this.props.unstableTrackAPI.track({
          tag: '_onScroll',
          positionY: position.y,
          scrollReason,
          calcReason,
          requestedScrollPosition: _this.state.requestedScrollPosition,
          scrollToRowReady: _this.state.scrollToRowReady
        });
      }

      if (!_this.state.scrollToRowReady && _this.state.requestedScrollPosition) {
        _this._markScrollToRowReadyAfterScroll(position, _this.state.requestedScrollPosition);
      }

      _this._calcRenderInfoAndRerender(position, calcReason, {
        forward,
        reason: SCROLL_REASON.OBSERVED
      });

      if (_this.props.onScroll) {
        _this.props.onScroll(position, isUserScrolling, isMouseDown);
      }
    });

    var keyMapper = List.createKeyMapper(props);
    var rowCache = new RowCache({
      keyMapper
    });
    var sizeCache = props.sizeCache;

    if (sizeCache) {
      List.updateSizeCache(sizeCache, props, keyMapper);
    } else {
      sizeCache = _this._initSizeCache({
        keyMapper
      });
    }

    var positionMap = _this._initPositionMap();

    var partialState = {
      dataHash: props.dataHash,
      sectionRowCount: props.dataHash ? null : List.calcSectionRowCount(props),
      scrollToRow: props.scrollToRow,
      scrollReason: props.scrollToRow ? SCROLL_REASON.REQUESTED_BY_PROPS : SCROLL_REASON.OBSERVED,
      positionMap,
      keyMapper,
      sizeCache,
      rowCache,
      position: {
        x: 0,
        y: 0
      },
      indexTree: _this._initIndexTree(props),
      containerHeight: props.height,
      // indicate whether position is ready for scrollToRow
      scrollToRowReady: props.variableHeight ? !props.scrollToRow : true
    };
    List.updatePositionMap(partialState, props);
    var requestedScrollPosition = props.scrollToRow ? List.calcScrollPositionForRow(partialState, props.scrollToRow) : {
      x: 0,
      y: 0
    };
    _this.state = _objectSpread(_objectSpread({
      requestedScrollPosition
    }, List.calcRenderInfo(partialState, props, {
      position: requestedScrollPosition,
      calcReason: CALC_REASON.REFRESH
    })), partialState);
    _this._timers = [];
    _this._updatePosId = 0; // enableMergeResizeSetState is true,
    // which proves that List tries to use BeforePaint api to merge setState
    // window.isEnableRunBeforePaint() is true,
    // which proves that BeforePaint api is allowed to use

    _this._mergeEnabled = window.isEnableRunBeforePaint && window.isEnableRunBeforePaint();
    return _this;
  }

  _createClass(List, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._scrollToRequestedPositionAfterRender(); // 1. 非变高列表在首屏渲染后重置 buffer
      // 2. 变高列表且设置了scrollToRow，在 scrollToRowReady 后重置 buffer
      //      @see _resetBufferSizeAfterRender caller
      // 3. 变高列表但是没有设置scrollToRow(this.state.scrollToRowReady == true)，也在didMount后需要尝试变更bufferSize


      if (!this.props.variableHeight || this.state.scrollToRowReady) {
        this._timers.push(setTimeout(() => {
          this._resetBufferSizeAfterRender();
        }));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._scrollToRequestedPositionAfterRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timers.forEach(timer => clearTimeout(timer));

      clearTimeout(this._resetScrollToRowReadyTimer);

      if (this._mergeEnabled && this._updatePosId !== 0) {
        window.cancelRunBeforePaint(this._updatePosId);
      }
    }
  }, {
    key: "_scrollToRequestedPositionAfterRender",
    value: function _scrollToRequestedPositionAfterRender() {
      var {
        scrollReason,
        requestedScrollPosition
      } = this.state;
      var {
        REQUESTED_BY_PROPS,
        REQUESTED_BY_API,
        REQUESTED_BY_RESIZE
      } = SCROLL_REASON;

      if (scrollReason === REQUESTED_BY_PROPS || scrollReason === REQUESTED_BY_API || scrollReason === REQUESTED_BY_RESIZE) {
        var _this$props$unstableT2;

        if ((_this$props$unstableT2 = this.props.unstableTrackAPI) !== null && _this$props$unstableT2 !== void 0 && _this$props$unstableT2.active) {
          this.props.unstableTrackAPI.track({
            tag: '_scrollToRequestedPositionAfterRender',
            requestedScrollPosition,
            containerHeight: this.state.containerHeight,
            totalHeight: this.state.positionMap.getTotalHeight(),
            scrollReason,
            stateScrollToRow: this.state.scrollToRow,
            stateRenderIndexPathBottom: this.state.renderIndexPathBottom
          });
        }

        this._scrollTo(requestedScrollPosition);
      }
    }
  }, {
    key: "_renderRangeChanged",
    value: function _renderRangeChanged(nextState) {
      var {
        indexTree
      } = this.state;
      return this.state.headerVisible !== nextState.headerVisible || this.state.footerVisible !== nextState.footerVisible || indexTree.compare(this.state.renderIndexPathTop, nextState.renderIndexPathTop) !== 0 || indexTree.compare(this.state.renderIndexPathBottom, nextState.renderIndexPathBottom) !== 0;
    }
  }, {
    key: "_initIndexTree",
    value: function _initIndexTree(props) {
      return new IndexTree({
        numberOfSections: props.numberOfSections,
        numberOfRows: props.numberOfRows
      });
    }
  }, {
    key: "_initSizeCache",
    value: function _initSizeCache(_ref2) {
      var {
        keyMapper
      } = _ref2;
      var {
        estimatedRowHeight,
        headerHeight,
        footerHeight,
        sectionHeaderHeight,
        sectionFooterHeight
      } = this.props;
      var sizeCache = new SizeCache({
        keyMapper,
        estimatedRowHeight,
        headerHeight,
        footerHeight,
        sectionHeaderHeight,
        sectionFooterHeight
      });
      return sizeCache;
    }
  }, {
    key: "_mergeSetStateAsPossible",
    value: function _mergeSetStateAsPossible(nextState) {
      if (!(this._mergeEnabled && this.props.enableMergeResizeSetState)) {
        this.setState(nextState);
        return;
      }

      if (this._updatePosId !== 0) {
        window.cancelRunBeforePaint(this._updatePosId);
      }

      this._updatePosId = window.requestRunBeforePaint(() => {
        this.setState(nextState);
        window.cancelRunBeforePaint(this._updatePosId);
        this._updatePosId = 0;
      });
    }
  }, {
    key: "_initPositionMap",
    value: function _initPositionMap() {
      return new PositionMap();
    }
  }, {
    key: "_calcRenderInfoAndRerender",
    value: function _calcRenderInfoAndRerender(position, calcReason, scrollOptions) {
      var _this$props$unstableT3;

      var nextState = List.calcRenderInfo(this.state, this.props, {
        position,
        forward: scrollOptions && scrollOptions.forward,
        calcReason
      });

      var rangeChanged = this._renderRangeChanged(nextState);

      if ((_this$props$unstableT3 = this.props.unstableTrackAPI) !== null && _this$props$unstableT3 !== void 0 && _this$props$unstableT3.active) {
        this.props.unstableTrackAPI.track({
          tag: '_calcRenderInfoAndRerender',
          rangeChanged,
          nextStateBottomIndexPath: nextState.renderIndexPathBottom,
          calcReason
        });
      }

      if (!rangeChanged) {
        if (scrollOptions) {
          this.state.scrollReason = scrollOptions.reason;
          this.state.position = position;
        } // return to minimize the call of setState


        return;
      }

      if (scrollOptions) {
        nextState.scrollReason = scrollOptions.reason;
      }

      this._mergeSetStateAsPossible(nextState);
    }
  }, {
    key: "_reCalcScrollToRowPositionByRowResizedAndRerender",
    value: function _reCalcScrollToRowPositionByRowResizedAndRerender() {
      var {
        scrollToRow
      } = this.state;

      if (scrollToRow) {
        var requestedScrollPosition = List.calcScrollPositionForRow(this.state, scrollToRow);
        var nextState = List.calcRenderInfo(this.state, this.props, {
          position: requestedScrollPosition,
          calcReason: CALC_REASON.RESIZED
        });
        nextState.requestedScrollPosition = requestedScrollPosition;
        nextState.scrollReason = SCROLL_REASON.REQUESTED_BY_RESIZE;

        this._mergeSetStateAsPossible(nextState);
      } else {
        this.forceUpdate();
      }
    }
  }, {
    key: "_reCalcPositionByRowResizedAndRerender",
    value: function _reCalcPositionByRowResizedAndRerender(diff) {
      var {
        position
      } = this.state;
      var nextPosition = {
        x: position.x,
        y: position.y + diff
      }; // row resize的时序不定，可能在调用scrollTo后触发onScroll前会再次resize，此时position会乱掉
      // 这里直接修改position

      this.state.position = nextPosition;
      this.state.requestedScrollPosition = nextPosition;
      this.state.scrollReason = SCROLL_REASON.REQUESTED_BY_RESIZE;

      this._scrollTo(nextPosition);

      this.forceUpdate();
    }
  }, {
    key: "_scrollTo",
    value: function _scrollTo(position) {
      if (!this._refScroller) {
        return;
      }

      this._refScroller.scrollTo(position);
    }
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition(position) {
      this._scrollTo(position);
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      this.setState({
        requestedScrollPosition: {
          x: 0,
          y: 0
        },
        scrollReason: SCROLL_REASON.REQUESTED_BY_API
      });
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      if (!this._refScroller) {
        return;
      }

      var maxPosition = this._refScroller.getMaxPosition();

      this.setState({
        requestedScrollPosition: maxPosition,
        scrollReason: SCROLL_REASON.REQUESTED_BY_API
      });
    }
  }, {
    key: "scrollToRow",
    value: function scrollToRow(scrollOptions) {
      if (!scrollOptions) {
        return;
      }

      var requestedScrollPosition = List.calcScrollPositionForRow(this.state, scrollOptions);
      var nextState = List.calcRenderInfo(this.state, this.props, {
        position: requestedScrollPosition,
        calcReason: CALC_REASON.REQUESTED_BY_API
      });
      nextState.requestedScrollPosition = requestedScrollPosition;
      nextState.scrollReason = SCROLL_REASON.REQUESTED_BY_RESIZE;
      nextState.scrollToRowReady = !this.props.variableHeight;
      nextState.scrollToRow = scrollOptions;
      this.setState(nextState);
    }
  }, {
    key: "getCurrentPosition",
    value: function getCurrentPosition() {
      return this.state.position;
    }
  }, {
    key: "getMaxPosition",
    value: function getMaxPosition() {
      return {
        x: 0,
        y: this.state.positionMap.getTotalHeight() - this.state.containerHeight
      };
    }
  }, {
    key: "getContainerHeight",
    value: function getContainerHeight() {
      return this.state.containerHeight;
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight() {
      return this.state.positionMap.getTotalHeight();
    }
  }, {
    key: "getRowPositionInfo",
    value: function getRowPositionInfo(indexPath) {
      return this.state.positionMap.getHeightRangeAt(indexPath);
    }
  }, {
    key: "getSectionHeaderPositionInfo",
    value: function getSectionHeaderPositionInfo(sectionIndex) {
      return this.state.positionMap.getSectionHeaderRangeAt(sectionIndex);
    }
  }, {
    key: "getSectionPositionInfo",
    value: function getSectionPositionInfo(sectionIndex) {
      return this.state.positionMap.getSectionRangeAt(sectionIndex);
    }
  }, {
    key: "getRowTopInfo",
    value: function getRowTopInfo() {
      var {
        position,
        positionMap
      } = this.state;
      var visibleIndexPathTop = positionMap.findIndexPathByPosition(position.y) || {
        section: 0,
        row: 0
      };
      var [rowStart] = positionMap.getHeightRangeAt(visibleIndexPathTop);
      return {
        indexPath: visibleIndexPathTop,
        offset: rowStart - position.y
      };
    }
  }, {
    key: "getRowBottomInfo",
    value: function getRowBottomInfo() {
      var {
        position,
        positionMap,
        containerHeight
      } = this.state;
      var positionAxis = position.y;
      var maxPositionAxis = positionAxis + containerHeight;
      var totalHeight = positionMap.getTotalHeight();

      if (totalHeight - containerHeight < 0) {
        maxPositionAxis = containerHeight;
      }

      var visibleIndexPathBottom = positionMap.findIndexPathByPosition(maxPositionAxis) || {
        section: 0,
        row: 0
      };
      var [rowStart] = positionMap.getHeightRangeAt(visibleIndexPathBottom);
      return {
        indexPath: visibleIndexPathBottom,
        offset: rowStart - position.y
      };
    }
  }, {
    key: "isNearBottom",
    value: function isNearBottom(threshold) {
      return this._refScroller.isNearBottom(threshold);
    }
  }, {
    key: "_markScrollToRowReady",
    value: function _markScrollToRowReady() {
      if (this.state.scrollToRowReady) {
        return;
      } // 下一个事件循环标记完成，让屏幕上所有Item的resize逻辑走完


      clearTimeout(this._resetScrollToRowReadyTimer);
      this._resetScrollToRowReadyTimer = setTimeout(() => {
        this.state.scrollToRowReady = true;

        this._resetBufferSizeAfterRender();
      });
    } // 对于变高列表，一开始并不能准确定位，需要渲染Item后才能知道计算出真实的位置，在定位item渲染后
    // 尝试再次定位

  }, {
    key: "_markScrollToRowReadyAfterRowResized",
    value: function _markScrollToRowReadyAfterRowResized() {
      this._markScrollToRowReady();
    }
  }, {
    key: "_markScrollToRowReadyAfterScroll",
    value: function _markScrollToRowReadyAfterScroll(currentPosition, requestPosition) {
      var maxPosition = this.getMaxPosition();
      var requestPositionAxis = Math.min(requestPosition.y, maxPosition.y);

      if (currentPosition.y === requestPositionAxis) {
        this._markScrollToRowReady();
      }
    }
  }, {
    key: "_resetBufferSizeAfterRender",
    value: function _resetBufferSizeAfterRender() {
      if (this.state.resetBufferSize === this.props.bufferSize) {
        return;
      }

      this.state.resetBufferSize = this.props.bufferSize;

      this._calcRenderInfoAndRerender(this.state.position, CALC_REASON.RESIZED);
    }
  }, {
    key: "getAlignTargetRange",
    value: function getAlignTargetRange() {
      var {
        unstableAlignOptions
      } = this.props;

      if (!unstableAlignOptions) {
        return null;
      }

      var {
        indexPath
      } = unstableAlignOptions;
      return this.state.positionMap.getHeightRangeAt(indexPath);
    }
  }, {
    key: "calcAlignTargetOffset",
    value: function calcAlignTargetOffset(originAlignTargetRange, currentAlignTargetRange) {
      var {
        unstableAlignOptions
      } = this.props;

      if (!unstableAlignOptions || !originAlignTargetRange || !currentAlignTargetRange) {
        return {
          shouldAlign: false,
          offset: 0
        };
      }

      var {
        alignType,
        onlyVisible
      } = unstableAlignOptions;
      var {
        containerHeight,
        position
      } = this.state;

      var isInValid = range => range[0] === 0 && range[1] === 0;

      if (isInValid(originAlignTargetRange) || isInValid(currentAlignTargetRange)) {
        return {
          shouldAlign: false,
          offset: 0
        };
      }

      var isInViewRange = n => position.y <= n && n <= position.y + containerHeight;

      var originAxisY = alignType === 'top' ? originAlignTargetRange[0] : originAlignTargetRange[1];
      var currentAxisY = alignType === 'top' ? currentAlignTargetRange[0] : currentAlignTargetRange[1];

      if (onlyVisible && !isInViewRange(originAxisY)) {
        return {
          shouldAlign: false,
          offset: 0
        };
      }

      return {
        shouldAlign: true,
        offset: currentAxisY - originAxisY
      };
    }
  }, {
    key: "_onRowResized",
    value: function _onRowResized(indexPath, rect, record) {
      var _this$props$recordRow2, _this$props2;

      var cachedHeight = this.state.sizeCache.get(indexPath);
      var {
        scrollToRowReady,
        indexTree,
        position,
        positionMap
      } = this.state;

      if (cachedHeight === rect.height) {
        var _this$props$recordRow, _this$props;

        this._markScrollToRowReadyAfterRowResized();

        (_this$props$recordRow = (_this$props = this.props).recordRowResizeTrack) === null || _this$props$recordRow === void 0 ? void 0 : _this$props$recordRow.call(_this$props, RESIZE_EFFECT_RESULT.HIT_CACHE_STRATEGY, record);
        return;
      }

      var resizeEffectResult = '';
      var originAlignRange = this.getAlignTargetRange(); // before `positionMap.setItemHeight`

      this.state.sizeCache.set(indexPath, rect.height);
      this.state.positionMap.setItemHeight(indexPath, rect.height);
      var currentAlignRange = this.getAlignTargetRange();
      var {
        shouldAlign,
        offset: alignOffset
      } = this.calcAlignTargetOffset(originAlignRange, currentAlignRange);

      if (shouldAlign) {
        this._reCalcPositionByRowResizedAndRerender(alignOffset);

        resizeEffectResult = RESIZE_EFFECT_RESULT.SHOULD_ALIGN_WITH_SCROLL_TO_POSITION;

        if (!scrollToRowReady) {
          this._markScrollToRowReadyAfterRowResized();
        }
      } else {
        if (scrollToRowReady) {
          // 默认对齐最上可见元素逻辑
          var visibleIndexPathTop = positionMap.findIndexPathByPosition(position.y);

          if (indexTree.compare(indexPath, visibleIndexPathTop) < 0) {
            this._reCalcPositionByRowResizedAndRerender(rect.height - cachedHeight);

            resizeEffectResult = RESIZE_EFFECT_RESULT.SCROLL_TO_ROW_READY_WITH_DIFF;
          } else {
            this.forceUpdate();
            resizeEffectResult = RESIZE_EFFECT_RESULT.SCROLL_TO_ROW_READY_WITHOUT_DIFF;
          }
        } else {
          var hasScrollToRow = Boolean(this.state.scrollToRow);

          this._markScrollToRowReadyAfterRowResized();

          this._reCalcScrollToRowPositionByRowResizedAndRerender();

          if (hasScrollToRow) {
            resizeEffectResult = RESIZE_EFFECT_RESULT.RESIZE_WITH_SCROLL_TO_ROW;
          } else {
            resizeEffectResult = RESIZE_EFFECT_RESULT.RESIZE_WITH_OTHER;
          }
        }
      }

      if (this.props.onRowResize) {
        this.props.onRowResize(this.state.keyMapper(indexPath), indexPath, rect);
      }

      (_this$props$recordRow2 = (_this$props2 = this.props).recordRowResizeTrack) === null || _this$props$recordRow2 === void 0 ? void 0 : _this$props$recordRow2.call(_this$props2, resizeEffectResult, record);
    }
  }, {
    key: "setPositionStyle",
    value: function setPositionStyle(style, top) {
      style.position = 'absolute';

      if (this.props.useTransform) {
        style.transform = "translate(0, ".concat(top, "px)");
      } else {
        style.top = "".concat(top, "px");
      }
    }
  }, {
    key: "renderScrollHolder",
    value: function renderScrollHolder() {
      var {
        positionMap
      } = this.state;
      var holderHeight = 1;
      var totalHeight = positionMap.getTotalHeight() - holderHeight;
      var style = {
        height: holderHeight,
        width: '100%'
      };
      this.setPositionStyle(style, totalHeight);
      return /*#__PURE__*/React.createElement("div", {
        key: "scroll_holder",
        style: style
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderScrollHolder(), /*#__PURE__*/React.createElement("div", {
        className: "list_items"
      }, this.renderHeader(), this.renderSections(), this.renderFooter()));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (!this.props.renderHeader || !this.state.headerVisible) {
        return null;
      }

      var headStyle = {};
      this.setPositionStyle(headStyle, 0);
      var header = this.props.renderHeader(headStyle); // clear header height in positionMap if it does't render

      if (!header) {
        this.state.positionMap.setHeaderHeight(0);
      }

      return header;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (!this.props.renderFooter || !this.state.footerVisible) {
        return null;
      }

      var [footerTop] = this.state.positionMap.getFooterHeightRange();
      var footerStyle = {};
      this.setPositionStyle(footerStyle, footerTop);
      var footer = this.props.renderFooter(footerStyle); // clear header height in positionMap if it does't render

      if (!footer) {
        this.state.positionMap.setFooterHeight(0);
      }

      return footer;
    }
  }, {
    key: "renderSections",
    value: function renderSections() {
      var {
        numberOfSections
      } = this.props;
      var {
        renderIndexPathTop,
        renderIndexPathBottom
      } = this.state;

      if (!renderIndexPathTop) {
        return null;
      }

      var sectionStart = renderIndexPathTop.section;
      var sectionEnd = Math.min(numberOfSections - 1, renderIndexPathBottom.section);
      var sections = [];

      for (var i = sectionStart; i <= sectionEnd; i++) {
        sections.push(this.renderHeaderInSection(i));
        sections.push(...this.renderRowsInSection(i));
        sections.push(this.renderFooterInSection(i));
      }

      return sections.filter(section => Boolean(section));
    }
  }, {
    key: "renderHeaderInSection",
    value: function renderHeaderInSection(sectionIndex) {
      if (!this.props.renderSectionHeader) {
        return null;
      }

      var {
        renderIndexPathTop,
        positionMap
      } = this.state;
      var {
        section: sectionIndexTop
      } = renderIndexPathTop; // don't render when current section is the top section && section.header is false

      if (sectionIndex === sectionIndexTop && renderIndexPathTop.row !== 0) {
        return null;
      }

      var [headerTop] = positionMap.getSectionHeaderRangeAt(sectionIndex);
      var headerStyle = {};
      this.setPositionStyle(headerStyle, headerTop);
      return this.props.renderSectionHeader(sectionIndex, headerStyle);
    }
  }, {
    key: "renderFooterInSection",
    value: function renderFooterInSection(sectionIndex) {
      if (!this.props.renderSectionFooter) {
        return null;
      }

      var {
        renderIndexPathBottom,
        indexTree,
        positionMap
      } = this.state;
      var {
        section: sectionIndexBottom
      } = renderIndexPathBottom; // don't render when current section is the bottom section && section.footer is false

      if (sectionIndex === sectionIndexBottom && !indexTree.isLastRowInSection(renderIndexPathBottom)) {
        return null;
      }

      var [footerTop] = positionMap.getSectionFooterRangeAt(sectionIndex);
      var footerStyle = {};
      this.setPositionStyle(footerStyle, footerTop);
      return this.props.renderSectionFooter(sectionIndex, footerStyle);
    }
  }, {
    key: "renderRowUI",
    value: function renderRowUI(record, indexPath, rowStyle, rowHeight, rowIndexMax) {
      var {
        renderRow,
        variableHeight,
        enableResizeObserverContentRect,
        renderRowStyle
      } = this.props;

      if (renderRowStyle) {
        var _renderRowStyle;

        var _style = (_renderRowStyle = renderRowStyle(record)) !== null && _renderRowStyle !== void 0 ? _renderRowStyle : {};

        rowStyle = Object.assign(rowStyle, _style);
      }

      if (!variableHeight) {
        return renderRow(record, indexPath, rowStyle, rowHeight, rowIndexMax);
      }

      var keyMapper = this.state.keyMapper;
      var key = keyMapper(indexPath);
      return /*#__PURE__*/React.createElement(Resize, {
        enableSizeNotifyDeferred: this.props.enableScrollerSizeNotifyDeferred,
        key: key,
        wrapperStyle: rowStyle,
        enableResizeObserverContentRect: enableResizeObserverContentRect,
        onResize: rect => this._onRowResized(indexPath, rect, record)
      }, renderRow(record, indexPath, {}, rowHeight, rowIndexMax));
    }
  }, {
    key: "renderRowInSection",
    value: function renderRowInSection(sectionIndex, rowIndex, rowIndexMax) {
      var {
        recordForRowAt
      } = this.props;
      var {
        positionMap
      } = this.state;
      var indexPath = {
        section: sectionIndex,
        row: rowIndex
      }; // const cachedRow = this.state.rowCache.get(indexPath);
      // if (cachedRow) return cachedRow;

      var record = recordForRowAt(indexPath);
      var [rowTop, rowBottom] = positionMap.getHeightRangeAt(indexPath);
      var rowHeight = rowBottom - rowTop;
      var rowStyle = {
        width: '100%',
        top: 0,
        left: 0
      };
      this.setPositionStyle(rowStyle, rowTop); // this.state.rowCache.set(indexPath, renderedRow);

      return this.renderRowUI(record, indexPath, rowStyle, rowHeight, rowIndexMax);
    }
  }, {
    key: "renderRowsInSection",
    value: function renderRowsInSection(sectionIndex) {
      var renderRowIndexMin = 0;
      var renderRowIndexMax = List.numberOfRowsForSection(this.props, sectionIndex) - 1;
      var {
        renderIndexPathTop,
        renderIndexPathBottom
      } = this.state;

      if (sectionIndex === renderIndexPathTop.section) {
        renderRowIndexMin = Math.max(0, renderIndexPathTop.row);
      }

      if (sectionIndex === renderIndexPathBottom.section) {
        renderRowIndexMax = Math.min(renderRowIndexMax, renderIndexPathBottom.row);
      }

      var rows = [];

      for (var i = renderRowIndexMin; i <= renderRowIndexMax; i++) {
        rows.push(this.renderRowInSection(sectionIndex, i, renderRowIndexMax));
      }

      return rows;
    }
  }, {
    key: "render",
    value: function render() {
      var {
        style,
        className,
        scrollingClassName
      } = this.props;
      var wrapperStyle = Object.assign({}, styles.wrapper, style);
      return /*#__PURE__*/React.createElement(Scroller, {
        ref: scroller => {
          this._refScroller = scroller;
        },
        style: wrapperStyle,
        className: className,
        lock: this.props.scrollLock,
        enableResizeObserverContentRect: this.props.enableResizeObserverContentRect,
        enableSizeNotifyDeferred: this.props.enableScrollerSizeNotifyDeferred,
        onScroll: this._onScroll,
        onScrollEnd: this.props.onScrollEnd,
        onContainerResize: this._onContainerResize,
        scrollingClassName: scrollingClassName
      }, this.renderContent());
    }
  }], [{
    key: "numberOfRowsForSection",
    value: function numberOfRowsForSection(props, sectionIndex) {
      var {
        numberOfRows
      } = props;
      return typeof numberOfRows === 'function' ? numberOfRows(sectionIndex) : numberOfRows;
    }
  }, {
    key: "updatePositionMap",
    value: function updatePositionMap(state, props) {
      var {
        positionMap,
        sizeCache
      } = state;
      var {
        numberOfSections
      } = props;
      positionMap.clear();
      positionMap.setHeaderHeight(sizeCache.getHeaderHeight());

      for (var i = 0; i < numberOfSections; i++) {
        positionMap.setSectionHeaderHeight(i, sizeCache.getSectionHeaderHeight(i));

        for (var j = 0; j < List.numberOfRowsForSection(props, i); j++) {
          var _indexPath = {
            section: i,
            row: j
          };
          positionMap.setItemHeight(_indexPath, sizeCache.get(_indexPath));
        }

        positionMap.setSectionFooterHeight(i, sizeCache.getSectionFooterHeight(i));
      }

      positionMap.setFooterHeight(sizeCache.getFooterHeight());
    }
  }, {
    key: "calcScrollPositionForRow",
    value: function calcScrollPositionForRow(state, _ref3) {
      var {
        indexPath,
        align = SCROLL_TO_ROW_ALIGN.START,
        offset = 0
      } = _ref3;
      var {
        positionMap,
        containerHeight,
        position
      } = state;
      var [maxStart, maxEnd] = positionMap.getHeightRangeAt(indexPath);
      var minStart = maxEnd - containerHeight;
      var calcStart;

      switch (align) {
        case SCROLL_TO_ROW_ALIGN.START:
          calcStart = maxStart;
          break;

        case SCROLL_TO_ROW_ALIGN.CENTER:
          calcStart = maxStart - (containerHeight - (maxEnd - maxStart)) / 2;
          break;

        case SCROLL_TO_ROW_ALIGN.END:
          calcStart = minStart;
          break;

        case SCROLL_TO_ROW_ALIGN.NEAREST:
          {
            if (Math.abs(maxStart - position.y) > Math.abs(minStart - position.y)) {
              calcStart = minStart;
            } else {
              calcStart = maxStart;
            }

            break;
          }

        default:
          calcStart = maxStart;
          break;
      }

      return {
        x: 0,
        y: calcStart - offset
      };
    }
  }, {
    key: "calcRenderInfo",
    value: function calcRenderInfo(state, props, options) {
      var _props$unstableTrackA;

      var {
        position,
        forward,
        calcReason
      } = options;
      var positionAxis = position.y;
      var {
        containerHeight,
        positionMap,
        indexTree
      } = state;
      var maxPositionAxis = positionAxis + containerHeight;
      var totalHeight = positionMap.getTotalHeight();

      if (totalHeight - containerHeight < 0) {
        maxPositionAxis = containerHeight;
      }

      var headerVisible = positionMap.isHeaderVisible(positionAxis);
      var footerVisible = positionMap.isFooterVisible(maxPositionAxis);
      var visibleIndexPathTop = positionMap.findIndexPathByPosition(positionAxis);

      if (!visibleIndexPathTop) {
        return {
          position,
          headerVisible,
          footerVisible
        };
      }

      var visibleIndexPathBottom = positionMap.findIndexPathByPosition(maxPositionAxis); // reach bottom, re calc top

      if (footerVisible) {
        var bottomHeight = positionMap.getHeightAt(visibleIndexPathBottom);
        visibleIndexPathTop = positionMap.findIndexPathByPosition(bottomHeight - containerHeight);
        headerVisible = positionMap.isHeaderVisible(maxPositionAxis - containerHeight);
      }

      var {
        minimumBufferDistance
      } = props;
      var finalRenderIndexPathTop = visibleIndexPathTop;
      var finalRenderIndexPathBottom = visibleIndexPathBottom;
      var preRenderIndexPathTop = state.renderIndexPathTop || visibleIndexPathTop;
      var preRenderIndexPathBottom = state.renderIndexPathBottom || visibleIndexPathBottom; // resize会导致visibleIndexPathTop/Bottom发生变化，使用最小的renderIndexPathTop/Bottom
      // 减少dom创建后立即销毁的开销

      if (calcReason === CALC_REASON.RESIZED) {
        finalRenderIndexPathTop = indexTree.min(visibleIndexPathTop, preRenderIndexPathTop);
        finalRenderIndexPathBottom = indexTree.max(visibleIndexPathBottom, preRenderIndexPathBottom);
      } else if (calcReason === CALC_REASON.SCROLL) {
        // resize后的滚动同上，需要考虑方向
        if (!forward.y) {
          finalRenderIndexPathTop = indexTree.min(visibleIndexPathTop, preRenderIndexPathTop);
        } else {
          finalRenderIndexPathBottom = indexTree.max(visibleIndexPathBottom, preRenderIndexPathBottom);
        }
      }

      var bufferSize = state.resetBufferSize ? state.resetBufferSize : 0;

      if (bufferSize) {
        var halfBufferSize = bufferSize >>> 1;

        if (calcReason !== CALC_REASON.SCROLL) {
          finalRenderIndexPathTop = indexTree.min(finalRenderIndexPathTop, indexTree.subCount(visibleIndexPathTop, halfBufferSize));
          finalRenderIndexPathBottom = indexTree.max(finalRenderIndexPathBottom, indexTree.addCount(visibleIndexPathBottom, halfBufferSize));
        } else if (calcReason === CALC_REASON.SCROLL) {
          var distance = 0;

          if (forward.y) {
            if (indexTree.isLast(preRenderIndexPathBottom)) {
              distance = Infinity;
            } else {
              distance = indexTree.sub(preRenderIndexPathBottom, visibleIndexPathBottom);
            }
          } else if (indexTree.isFirst(preRenderIndexPathTop)) {
            distance = Infinity;
          } else {
            distance = indexTree.sub(visibleIndexPathTop, preRenderIndexPathTop);
          }

          if (distance <= minimumBufferDistance) {
            finalRenderIndexPathTop = indexTree.subCount(visibleIndexPathTop, halfBufferSize);
            finalRenderIndexPathBottom = indexTree.addCount(visibleIndexPathBottom, halfBufferSize);
          } else {
            finalRenderIndexPathTop = state.renderIndexPathTop;
            finalRenderIndexPathBottom = state.renderIndexPathBottom;
          }
        }
      }

      if ((_props$unstableTrackA = props.unstableTrackAPI) !== null && _props$unstableTrackA !== void 0 && _props$unstableTrackA.active) {
        props.unstableTrackAPI.track({
          tag: 'calcRenderInfo',
          position,
          headerVisible,
          footerVisible,
          renderIndexPathTop: finalRenderIndexPathTop,
          renderIndexPathBottom: finalRenderIndexPathBottom,
          forward,
          calcReason
        });
      }

      return {
        position,
        headerVisible,
        footerVisible,
        renderIndexPathTop: finalRenderIndexPathTop,
        renderIndexPathBottom: finalRenderIndexPathBottom
      };
    }
  }, {
    key: "createKeyMapper",
    value: function createKeyMapper(props) {
      var {
        keyMapper,
        recordForRowAt
      } = props;
      return keyMapper || defaultKeyMapper(recordForRowAt);
    }
  }, {
    key: "calcSectionRowCount",
    value: function calcSectionRowCount(props) {
      var {
        numberOfSections
      } = props;
      var sectionRowsCount = [];

      for (var i = 0; i < numberOfSections; i++) {
        sectionRowsCount.push(this.numberOfRowsForSection(props, i));
      }

      return sectionRowsCount;
    }
  }, {
    key: "sectionRowChanged",
    value: function sectionRowChanged(preSecitonRowCount, nextSectionRowCount) {
      if (preSecitonRowCount.length !== nextSectionRowCount.length) {
        return true;
      }

      for (var i = 0; i < preSecitonRowCount.length; i++) {
        if (preSecitonRowCount[i] !== nextSectionRowCount[i]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "updateSizeCache",
    value: function updateSizeCache(sizeCache, nextProps, keyMapper) {
      var {
        headerHeight,
        footerHeight,
        sectionHeaderHeight,
        sectionFooterHeight,
        estimatedRowHeight
      } = nextProps;
      sizeCache.setHeaderHeight(headerHeight);
      sizeCache.setFooterHeight(footerHeight);
      sizeCache.setSectionHeaderHeight(sectionHeaderHeight);
      sizeCache.setSectionFooterHeight(sectionFooterHeight);
      sizeCache.setKeyMapper(keyMapper);
      sizeCache.setEstimatedRowHeight(estimatedRowHeight);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, preState) {
      var nextState = null;
      var dataChanged = false;
      var {
        sectionRowCount,
        dataHash
      } = preState;
      var {
        dataHash: nextDataHash
      } = nextProps;
      var nextSectionRowCount;

      if (dataHash) {
        dataChanged = dataHash !== nextDataHash;
      } else {
        nextSectionRowCount = List.calcSectionRowCount(nextProps);
        dataChanged = List.sectionRowChanged(sectionRowCount, nextSectionRowCount);
      }

      if (dataChanged) {
        nextState = _objectSpread({}, preState);
        nextState.sectionRowCount = nextSectionRowCount;
        nextState.dataHash = nextDataHash;
        var newKeyMapper = List.createKeyMapper(nextProps);
        List.updateSizeCache(nextState.sizeCache, nextProps, newKeyMapper);
        nextState.keyMapper = newKeyMapper;
        nextState.rowCache.setKeyMapper(newKeyMapper);
        nextState.indexTree.update(nextProps);
        var {
          positionMap
        } = preState;
        positionMap.clear();
        List.updatePositionMap(preState, nextProps);
        var requestedScrollPosition = preState.position;

        if (preState.scrollToRow !== nextProps.scrollToRow) {
          if (nextProps.scrollToRow) {
            var _nextProps$unstableTr;

            nextState.scrollToRowReady = !nextProps.variableHeight;
            requestedScrollPosition = List.calcScrollPositionForRow(preState, nextProps.scrollToRow);
            nextState.requestedScrollPosition = requestedScrollPosition;
            nextState.scrollReason = SCROLL_REASON.REQUESTED_BY_PROPS;
            nextState.scrollToRow = nextProps.scrollToRow; // 尝试开始记录props.scrollToRow的更新过程

            if ((_nextProps$unstableTr = nextProps.unstableTrackAPI) !== null && _nextProps$unstableTr !== void 0 && _nextProps$unstableTr.active) {
              nextProps.unstableTrackAPI.track({
                tag: 'getDerivedStateFromProps.nextPropsScrollToRowChange',
                prevRequestedScrollPosition: preState.position,
                nextScrollToRow: nextProps.scrollToRow,
                nextRequestedScrollPosition: requestedScrollPosition
              });
            }
          } else {
            nextState.scrollToRow = null;
            nextState.scrollToRowReady = true;
          }
        }

        var {
          headerVisible,
          footerVisible,
          renderIndexPathTop,
          renderIndexPathBottom
        } = List.calcRenderInfo(nextState, nextProps, {
          position: requestedScrollPosition,
          calcReason: CALC_REASON.REFRESH
        });
        nextState.headerVisible = headerVisible;
        nextState.footerVisible = footerVisible;
        nextState.renderIndexPathTop = renderIndexPathTop;
        nextState.renderIndexPathBottom = renderIndexPathBottom;
      }

      return nextState;
    }
  }]);

  return List;
}(React.Component);

_defineProperty(List, "defaultProps", defaultProps);

_defineProperty(List, "propTypes", void 0);

List.propTypes = {
  style: PropTypes.object,
  height: PropTypes.number,
  position: PropTypes.number,
  // map indexPath to key
  keyMapper: PropTypes.func,
  // TODO
  scrollOnWindow: PropTypes.bool,
  // indicate whether the data changes
  dataHash: PropTypes.number,
  // TODO not yet support
  direction: PropTypes.oneOf([_DIRECTION.VERTICAL, _DIRECTION.HORIZONTAL]),
  numberOfSections: PropTypes.number,
  numberOfRows: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  rowHeight: PropTypes.number,
  headerHeight: PropTypes.number,
  footerHeight: PropTypes.number,
  // indicate whether row's height will be changed after render
  variableHeight: PropTypes.bool,
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  sectionHeaderHeight: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  sectionFooterHeight: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  renderSectionHeader: PropTypes.func,
  renderRow: PropTypes.func.isRequired,
  renderSectionFooter: PropTypes.func,
  recordForRowAt: PropTypes.func.isRequired,
  estimatedRowHeight: PropTypes.number,
  estimatedSectionHeaderHeight: PropTypes.number,
  estimatedSectionFooterHeight: PropTypes.number,
  scrollToRow: PropTypes.object,
  bufferSize: PropTypes.number,
  minimumBufferDistance: PropTypes.number,
  onContainerResize: PropTypes.func,
  onScroll: PropTypes.func,
  onScrollEnd: PropTypes.func,
  scrollLock: PropTypes.bool,
  useTransform: PropTypes.bool
};
export var DIRECTION = _DIRECTION;
export default List;